import { _axios } from "../utils/axios";
import { jwtDecode } from "jwt-decode";

/**
 * Interface for decoded JWT payload.
 */
interface DecodedToken {
  tenant_id: string;
  user_details_id: number;
  name: string;
  user_id: number;
  email: string;
  mobile_number: string;
  gov_id_number: string;
  document_type: string;
  office_address: string;
  user_type: string;
  user_salutation: string;
  gov_id_document: string;
  document_certificate: string;
  licence_certificate: string;
  email_status: number;
  mobile_status: number;
  regestration_status: number;
  updated_date: string; // ISO 8601 format (Date)
  created_by: string | null;
  modified_by: string | null;
  experience_certificate: string | null;
  iat: number; // Issued at (Unix Timestamp)
  exp: number; // Expiry (Unix Timestamp)
  data:any;
  mobile:string | number | null
}

/**
 * Fetch user details, validate and decode JWT.
 * @param {number} userId - The user ID to fetch details.
 * @returns {Promise<{ success: boolean, data?: DecodedToken, error?: string }>}
 */
export async function fetchAndVerifyUserDetails(
  userId: number,
  isAllProfile = false
): Promise<{ success: boolean; data?:{data :DecodedToken } ; error?: string }> {
  try {
    if (!userId) {
      throw new Error("User ID is required");
    }

    // 1️⃣ Fetch Token from `/details` using userId
    const detailsResponse = await _axios.post<{
      success: boolean;
      data?: string;
    }>("/user-details/details", { user_id: userId ,isAllProfile });

    if (!detailsResponse.data.success || !detailsResponse.data.data) {
      throw new Error("Failed to fetch user details");
    }

    const token: string = detailsResponse.data.data; // Extract JWT token
    console.log("Received Token:", token);

    // 2️⃣ Validate Token using `/validate-details`
    const validateResponse = await _axios.post<{
      valid: boolean;
      message: string;
      user?: DecodedToken;
    }>("/user-details/validate-details", { token, user_id: userId });

    if (!validateResponse.data.valid || !validateResponse.data.user) {
      throw new Error("Invalid token detected");
    }

    console.log("Token Validated Successfully");

    // 3️⃣ Decode JWT to extract user details with error handling
    let decodedData: DecodedToken;
    try {
      decodedData = jwtDecode<DecodedToken>(token);
    } catch (decodeError) {
      throw new Error("Error decoding token: Possible tampering detected");
    }

    return { success: true, data:decodedData  };
  } catch (error: any) {
    console.error("JWT Verification Error:", error.message);
    return { success: false, error: error.message };
  }
}
